import { usePermission } from "@iotos/ims-auth-sdk/permissions";

const GENERAL_SUBJECT = "general";

export function useCanViewGeneral(): boolean {
  return usePermission("view", GENERAL_SUBJECT);
}

export function useCanEditGeneral(): boolean {
  return usePermission("edit", GENERAL_SUBJECT);
}
